module.exports = __webpack_public_path__ + "static/media/VR3@2x.9ed73ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/VR/VR3@2x.png
// module id = 731
// module chunks = 0